var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.root ? 'button' : 'div',{tag:"component",staticClass:"menu-control ui-btn flex--col-center-center",class:{
    'menu-control--root': _vm.root,
    'menu-control--fade': _vm.getShouldFade
  },attrs:{"aria-label":"Show the menu"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_c('div',{staticClass:"menu-icon-placeholder",class:{
      open: _vm.active
    },attrs:{"id":"bleach-menu-icon"}},[_vm._l((3),function(index){return [_c('span',{key:index,style:({
          backgroundColor: _vm.uiColor
        })})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }